import React from 'react';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import PersonIcon from '@material-ui/icons/Person';
import DescriptionIcon from '@material-ui/icons/Description';
import {Link} from "react-scroll";

const useStyles=makeStyles((themes)=>({

    icon:{
        margin:"10px",
        color:"white",
        
    }
 
    }));

export default function SideBar(){

    const classes =useStyles();
    
    return(
        <div>
            <Grid container direction="column"> 
                <Grid item>
                <Link
                       activeClass="active" to="home" spy={true} smooth={true} offset={0} duration={1000}>
                    
                    <HomeIcon className={classes.icon}></HomeIcon></Link>
                </Grid>
                <Grid item>
                    <Link
                       activeClass="active" to="aboutme" spy={true} smooth={true} offset={0} duration={1000}>
                    
                    <PersonIcon className={classes.icon}></PersonIcon></Link>
                </Grid>
                <Grid item>
                <Link
                       activeClass="active" to="projects" spy={true} smooth={true} offset={0} duration={1000}>
                    <DescriptionIcon className={classes.icon}></DescriptionIcon></Link>
                </Grid>
            </Grid>
  

        </div>

    )
}